import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { DataLayer } from '@alfa-bank/site-data-layer';

import styles from '../../styles/styles.css';
import { BannerLink } from '../banner-link';
import { DropDown } from '../drop-down';

import { SubsectionLink as Component } from './subsection-link';
import type { IDeps, TBannerLink } from './models';

export const SubsectionLink = createWidget<IDeps, TBannerLink>({
    BannerLink,
    DataLayer,
    DropDown,
    styles,
})(Component);
